import React from "react";

export const Illustration8 = () => {
	return (
		<svg width={141} height={68} viewBox="0 0 141 68" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21.4233 22.3649C7.40228 39.2134 19.2201 57.9865 29.4975 66H116.807C132.118 38.9505 120.59 5.04954 104.573 1.05235C84.5527 -3.94363 76.3323 10.631 63.9765 7.71365C39.3139 1.89051 31.6099 10.124 21.4233 22.3649Z"
				fill="#F5FAFF"
			/>
			<path d="M0 66H141" stroke="#315C84" strokeWidth={2} />
			<path
				d="M91 36H126C128.209 36 130 37.7909 130 40V66H87V40C87 37.7909 88.7909 36 91 36Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M24 24H63C65.2091 24 67 25.7909 67 28V66H20V28C20 25.7909 21.7909 24 24 24Z"
				fill="#C4DBF1"
				fillOpacity={0.46}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M50 14H90C92.2091 14 94 15.7909 94 18V66H46V18C46 15.7909 47.7909 14 50 14Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={52} y1={40} x2={74} y2={40} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={26} y1={40} x2={45} y2={40} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={26} y1={50} x2={45} y2={50} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={26} y1={59} x2={45} y2={59} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={52} y1={59} x2={77} y2={59} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={52} y1={49} x2={73} y2={49} stroke="#C4DBF1" strokeWidth={2} />
			<circle cx={88.9752} cy={45.4253} r={14.3451} transform="rotate(3.84747 88.9752 45.4253)" fill="#F9FCFF" />
			<circle
				cx={88.9754}
				cy={45.4253}
				r={10.886}
				transform="rotate(3.84747 88.9754 45.4253)"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={97.2122} y1={51.7267} x2={107.35} y2={59.8026} stroke="#315C84" strokeWidth={3} />
			<path
				d="M73.885 22L70 25.885L66.115 22L64 24.115L67.885 28L64 31.885L66.115 34L70 30.115L73.885 34L76 31.885L72.115 28L76 24.115L73.885 22Z"
				fill="#315C84"
			/>
			<circle cx={28.5} cy={32.5} r={3} stroke="#315C84" />
			<circle cx={100.5} cy={29.5} r={1} stroke="#315C84" />
			<circle cx={29.5} cy={14.5} r={1} stroke="#315C84" />
			<line x1={108} y1={19.5} x2={111} y2={19.5} stroke="#315C84" />
			<line x1={109.5} y1={18} x2={109.5} y2={21} stroke="#315C84" />
			<line x1={45} y1={10.5} x2={48} y2={10.5} stroke="#315C84" />
			<line x1={46.5} y1={9} x2={46.5} y2={12} stroke="#315C84" />
		</svg>
	);
};
